<template>
  <div class="appointment">
    <p class="appointment__title">
      {{ title }}
    </p>
    <p class="appointment__date">{{ appointmentPeriod }}</p>
    <div class="appointment__bottom">
      <p class="appointment__participants">{{ participants }}</p>
      <button class="appointment__action" @click="actionHandler(ACTIONS.EDIT_APPOINTMENT)">
        <HdIcon :src="arrowIcon" height="28" width="28" />
      </button>
    </div>
  </div>
</template>

<script>
import { HdIcon } from 'homeday-blocks';
import { arrow as arrowIcon } from 'homeday-assets';
import { PARTICIPANT_ROLE_TYPES } from '@/config/TRANSLATION_CONSTANTS';
import dashboardCardMixin from '@/mixins/dashboardCardMixin';

export default {
  name: 'AppointmentCard',
  components: { HdIcon },
  mixins: [dashboardCardMixin],
  props: {
    deal: {
      type: Object,
      required: true,
    },
    cardDynamicData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      arrowIcon,
    };
  },
  computed: {
    title() {
      return this.cardDynamicData.title;
    },
    appointmentPeriod() {
      const fromDate = new Date(this.cardDynamicData.from);
      const toDate = new Date(this.cardDynamicData.to);

      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      };

      const [date, from] = new Intl.DateTimeFormat('de-DE', options).format(fromDate).split(',');
      const [, to] = new Intl.DateTimeFormat('de-DE', options).format(toDate).split(',');

      return this.$t('DASHBOARD.CARD.EXPANDED.TASK_AND_APPOINTMENTS.APPOINTMENT.PERIOD', {
        date,
        from,
        to,
      });
    },
    formattedParticipants() {
      return this.cardDynamicData.participants.map((i) => {
        const gender = i.gender || 'male';
        const role = i.role || 'other';
        return {
          ...i,
          gender,
          role,
          translatedRole: PARTICIPANT_ROLE_TYPES(gender)[role.toUpperCase()],
        };
      });
    },
    participants() {
      return this.$t('DASHBOARD.CARD.EXPANDED.TASK_AND_APPOINTMENTS.APPOINTMENT.WITH', {
        value: this.formattedParticipants
          .map((i) => `${i.full_name} (${i.translatedRole})`)
          .join(', '),
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.appointment {
  $root: &;

  &__title {
    @include fontGroup(100, 600);
    color: $primary-color;
    margin-bottom: $sp-s;
  }

  &__date {
    @include fontGroup(90, 400);
    color: $primary-color;
    margin-bottom: $sp-xs;
  }

  &__participants {
    @include fontGroup(90, 400);
    color: $primary-color;
  }

  &__bottom {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  &__action {
    border: none;
    background: none;
    padding: 0;
    cursor: pointer;

    ::v-deep {
      path {
        fill: getShade($secondary-color, 120);
      }
    }
  }
}
</style>
